/* global axios */
import ApiClient from './ApiClient';

class ProductsAPI extends ApiClient {
  constructor() {
    super('products', { accountScoped: true });
  }

  search({ q }) {
    return axios.get(`${this.url}/search`, { params: { q } });
  }
}

export default new ProductsAPI();


